module.exports = __webpack_public_path__ + "img/9788995574782.87adb596.jpg";